import * as actions from './Actions';

// Normalizer for an option payload
const parseOption = (payload = {}) => {
  const rawCorrect = payload.isCorrect;
  let isCorrect;
  if (typeof rawCorrect === 'boolean') {
    isCorrect = rawCorrect;
  } else if (rawCorrect === 1 || rawCorrect === '1' || rawCorrect === 'true' || rawCorrect === 'TRUE') {
    isCorrect = true;
  } else if (rawCorrect === 0 || rawCorrect === '0' || rawCorrect === 'false' || rawCorrect === 'FALSE') {
    isCorrect = false;
  } else {
    // Keep undefined if not provided
    isCorrect = undefined;
  }

  return {
    optionId: payload.optionId ?? payload.id,
    questionId: Number(payload.questionId ?? 0),
    optionText: payload.optionText || '',
    isCorrect,
    order: Number(payload.optionOrder ?? payload.order ?? 0),
    createdAt: payload.createdAt || new Date().toISOString(),
    updatedAt: payload.updatedAt || new Date().toISOString(),
  };
};

export const optionQuizReducer = (state = [], action) => {
  switch (action.type) {
    case actions.INITIALIZE_QUESTION_OPTIONS:
      return Array.isArray(action.payload) ? action.payload.map(parseOption) : [];

    case actions.ADD_QUESTION_OPTION:
      return [...state, parseOption(action.payload)];

    case actions.UPDATE_QUESTION_OPTION: {
      const id = action.payload?.optionId ?? action.payload?.id;
      const idNum = Number(id);
      return state.map((o) => (Number(o.optionId) === idNum ? parseOption(action.payload) : o));
    }

    case actions.DELETE_QUESTION_OPTION: {
      const id = action.optionId ?? action.id;
      const idNum = Number(id);
      return state.filter((o) => Number(o.optionId) !== idNum);
    }

    case actions.CLEAR_QUESTION_OPTIONS:
      return [];

    default:
      return state;
  }
};

export default optionQuizReducer;
